var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4323 16.2274C13.3735 14.5138 16.3142 12.8008 19.2555 11.0872C19.6027 10.8849 19.8139 10.5115 19.8089 10.1103C19.7799 7.83164 19.7509 5.55242 19.7219 3.27376C19.7113 2.42616 18.7963 1.90066 18.0585 2.31805L3.23799 10.7043C2.88858 10.9022 2.67236 11.2728 2.67236 11.6745V29.9629C2.67236 30.3586 2.8819 30.7241 3.22294 30.9242L9.61646 34.6729C10.3481 35.102 11.2721 34.5888 11.2944 33.7412C11.3562 31.3956 11.4187 29.0495 11.4805 26.704C11.4905 26.3173 11.7012 25.9634 12.0361 25.7689C17.4009 22.6599 22.7663 19.5509 28.1311 16.442C28.4782 16.2408 28.6906 15.8685 28.6867 15.4673C28.6633 12.8599 28.6393 10.2524 28.6159 7.64495C28.6081 6.77172 29.5616 6.22894 30.3083 6.68144L36.791 10.6107C37.1242 10.8125 37.3276 11.1741 37.3276 11.5636V30.051C37.3276 30.4461 37.1181 30.8116 36.7776 31.0117C31.8614 33.8994 26.9458 36.7872 22.0296 39.6755C21.2984 40.1052 20.3745 39.593 20.3511 38.7454C20.2864 36.4138 20.2218 34.0817 20.1566 31.7501C20.1454 31.3522 20.3477 30.9788 20.6865 30.7698L29.3097 25.4635",
    stroke: "#00C569",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogoIcon);
export default __webpack_public_path__ + "static/media/hrms-logo-icon.5745f5eb75d58feb22d9e5d943b52b56.svg";
export { ForwardRef as ReactComponent };